import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProjectSnapshot, SharedComponentSet } from '@paragon/contract-library';

export type SharedComponentSetState = {
  readonly sharedComponentSet: SharedComponentSet | null;
  readonly projectSnapshot: ProjectSnapshot | null;
  readonly componentDesignGuidsThatNoLongerExistInSourceProject: readonly string[];
  readonly sharedComponentSetIsMissingJacks: boolean | null;
  readonly errorLoadingSharedComponentSet: boolean;
};
const initialState: SharedComponentSetState = {
  sharedComponentSet: null,
  projectSnapshot: null,
  componentDesignGuidsThatNoLongerExistInSourceProject: [],
  sharedComponentSetIsMissingJacks: null,
  errorLoadingSharedComponentSet: false,
};

const sharedComponentSetSlice = createSlice({
  name: 'sharedComponentSet',
  initialState,
  reducers: {
    sharedComponentSetLoaded: (state, action: PayloadAction<SharedComponentSet>) => {
      state.sharedComponentSet = castDraft(action.payload);
    },
    setProjectSnapshot: (state, action: PayloadAction<ProjectSnapshot>) => {
      state.projectSnapshot = castDraft(action.payload);
    },
    setComponentDesignGuidsThatNoLongerExistInSourceProject: (state, action: PayloadAction<readonly string[]>) => {
      state.componentDesignGuidsThatNoLongerExistInSourceProject = castDraft(action.payload);
    },
    setSharedComponentSetIsMissingJacks: (state, action: PayloadAction<boolean>) => {
      state.sharedComponentSetIsMissingJacks = action.payload;
    },
    errorLoadingSharedComponentSet: (state) => {
      state.errorLoadingSharedComponentSet = true;
    },
  },
});

export const {
  sharedComponentSetLoaded,
  setProjectSnapshot,
  setComponentDesignGuidsThatNoLongerExistInSourceProject,
  setSharedComponentSetIsMissingJacks,
  errorLoadingSharedComponentSet,
} = sharedComponentSetSlice.actions;
export const sharedComponentSet = sharedComponentSetSlice.reducer;
